import { Box, Modal, Typography } from "@mui/material";
import Input from "../Common/Input";
import Button from "../Common/Button";
import Select from "../Common/Select";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import {
  addOrgUser,
  updateOrgUser,
} from "../../store/organizationUser/organizationUser.action";
import { closeDialogue } from "../../util/Dialogue";
import { isEmail, isPhone } from "../../util/textValidation";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  borderRadius: "13px",
  border: "1px solid #C9C9C9",
  boxShadow: 24,
  p: "19px",
};

const CreateOrgMembers = ({ currentTab }) => {
  const dispatch = useDispatch();
  const { dialogue, dialogueData } = useSelector((state) => state.dialogue);
  const { departments, roles } = useSelector((state) => state.organizationUser);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [department, setDepartment] = useState("");
  const [role, setRole] = useState("org_viewer");

  const [errors, setError] = useState({
    email: "",
    department: "",
    role: "",
  });

  useEffect(() => {
    if (dialogueData) {
      console.log(dialogueData);

      setName(dialogueData.userId?.nickName);
      setEmail(dialogueData.email);
      setRole(dialogueData.role);
      setDepartment(dialogueData.departmentId?._id);
    }
  }, [dialogueData]);

  const closePopup = () => {
    resetForm();
    closeDialogue(dispatch);
  };

  const handleSubmit = () => {
    if (!(email || phone) || !role) {
      let error = {};
      if (!email && !phone) error.emailPhone = "Email or Phone is required!";
      if (!role) error.role = "Role is required!";

      return setError({ ...error });
    } else {
      const isValidEmail = isEmail(email);
      const isValidPhone = isPhone(phone);

      if (email && !isValidEmail) {
        return setError({
          ...errors,
          emailPhone: "Enter a valid email!",
        });
      }

      if (phone && !isValidPhone) {
        return setError({
          ...errors,
          emailPhone: "Enter a valid phone number!",
        });
      }

      const payload = {
        department: department,
        role,
      };

      if (isValidEmail) {
        payload.email = email;
      } else if (isValidPhone) {
        payload.phone = phone;
      }

      if (dialogueData) {
        console.log("UPDATE ORG USER ", payload);
        dispatch(updateOrgUser(dialogueData._id, payload));
      } else {
        console.log("CREATE ORG USER ", payload);
        dispatch(addOrgUser(payload, currentTab));
      }

      closePopup();
    }
  };

  const resetForm = () => {
    setName("");
    setEmail("");
    setDepartment("");
    setRole("org_viewer");
  };

  return (
    <Modal
      open={dialogue}
      onClose={closePopup}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} className="create-member-model create-modal">
        <Typography id="modal-modal-title" variant="h6" component="h2">
          {dialogueData ? "Edit Member" : "Add Member"}
        </Typography>
        <form>
          <div className="row row-gap-4">
            {name && (
              <Typography variant="h6" component="h4">
                {name}
              </Typography>
            )}
            <div className="col-12">
              <div className="col-12 d-flex gap-4 flex-column flex-lg-row align-items-center">
                <Input
                  classNames={{ root: "w-100" }}
                  label={"Email"}
                  name={"email"}
                  type={"email"}
                  placeholder={"Enter Email.."}
                  disabled={dialogueData || phone}
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    if (e.target.value) {
                      return setError({
                        ...errors,
                        emailPhone: "",
                      });
                    }
                  }}
                />

                {!dialogueData && <span className="text-secondary">OR</span>}

                <Input
                  classNames={{ root: "w-100" }}
                  label={"Phone"}
                  name={"phone"}
                  type={"email"}
                  placeholder={"Enter Phone.."}
                  disabled={dialogueData || email}
                  value={phone}
                  onChange={(e) => {
                    setPhone(e.target.value);
                    if (e.target.value) {
                      return setError({
                        ...errors,
                        emailPhone: "",
                      });
                    }
                  }}
                />
              </div>
              {errors.emailPhone && (
                <p className="errorMessage">{errors.emailPhone}</p>
              )}
            </div>

            <div className="col-12 col-md-6">
              <Select
                label={"Department"}
                placeholder={"Select Department"}
                options={departments.map((d) => ({
                  label: d.name,
                  value: d._id,
                }))}
                value={department}
                onValueChange={(value) => setDepartment(value)}
              />
            </div>

            <div className="col-12 col-md-6">
              <Select
                label="Role"
                placeholder={"Select Role"}
                options={roles}
                value={role}
                onValueChange={(value) => {
                  setRole(value);
                  if (!value) {
                    setError({
                      ...errors,
                      role: "Role is required!",
                    });
                  } else {
                    setError({
                      ...errors,
                      role: "",
                    });
                  }
                }}
                errorMessage={errors.role}
              />
            </div>
          </div>

          <div className="mt-3 d-flex justify-content-end gap-2">
            <Button type={"button"} className={"close"} onClick={closePopup}>
              Cancel
            </Button>
            <Button type={"button"} onClick={handleSubmit} className={"submit"}>
              {dialogueData ? "Update" : "Submit"}
            </Button>
          </div>
        </form>
      </Box>
    </Modal>
  );
};

export default CreateOrgMembers;
